export default {
    breadcrumbs: {
        bills: 'Relatórios de Faturas',
    },

    bills: {
        texts: {
            download: 'Baixar',
            filter: 'Filtrar',
            month: 'Período',
        },
        table: {
            'reseller-name': 'Parceiro',
            customers: 'Clientes',
            value: 'Valor de Custo',
            'over-value': 'Valor de Venda',
            expand: 'Detalhes',
            customer: 'Cliente',
            'start-at': 'Início',
            'end-at': 'Fim',
        },
        tabs: {
            all: 'Todos',
        },
    },

    bookings: {
        table: {
            vcode: 'Vindi Code',
            active_at: 'Dta. Ativação',
            month_year: 'Mês Base',
            schema: 'Schema',
            customer: {
                id: 'Id Cliente',
                trade_name: 'Nome Empresa (FANTASIA)',
                legal_name: 'Razão Social',
            },
            reseller: {
                id: 'Id Parceiro',
                trade_name: 'Parceiro',
            },
            subject: 'Plano|App',
            price: 'Valor',
            discounts: 'Descontos',
            final_price: 'Valor Final',
            bookings: 'Bookings',
            totalGross: 'Total Bruto',
            totalDiscounts: 'Total Descontos',
            totalNet: 'Total Líquido',
        },
    },
}
